import { axiosRef } from '.';

export const fetchCarriersList = (payload?: any) => {
  let url = `/carriers?`;
  if (payload && payload?.pageSize) {
    url = url + `page_size=${payload.pageSize}&page=${payload.page}&`;
  }
  if (payload && payload.search && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  if (payload && payload.is_kilogram) {
    url = url + `is_kilogram=${payload.is_kilogram}&`;
  }
  if (payload && payload.is_pharma) {
    url = url + `is_pharma=${payload.is_pharma}&`;
  }
  if (payload && payload.is_dangerous_goods) {
    url = url + `is_dangerous_goods=${payload.is_dangerous_goods}&`;
  }
  return axiosRef.get(url);
};

export const fetchCarrierAccountsList = (payload?: any) => {
  let url = `/carrier_accounts?`;
  if (payload && payload?.pageSize) {
    url = url + `page_size=${payload.pageSize}&page=${payload.page}&`;
  }
  if (payload && payload.search && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  if (payload && payload.carrier_code) {
    url = url + `carrier_code=${payload.carrier_code}&`;
  }
  if (payload && payload.account) {
    url = url + `account=${payload.account}&`;
  }
  return axiosRef.get(url);
};

export const addCarrierAccounts = (payload: any) =>
  axiosRef.post(`/carrier_accounts`, payload);

export const editCarrierAccounts = (payload: any) =>
  axiosRef.put(`/carrier_accounts/${payload.id}`, payload);

export const deleteCarrierAccounts = (id: any) =>
  axiosRef.delete(`/carrier_accounts/${id}`);

export const fetchCarrierMarkupsList = (payload?: any) => {
  let url = `/carrier_markups?`;
  if (payload && payload?.pageSize) {
    url = url + `page_size=${payload.pageSize}&page=${payload.page}&`;
  }
  if (payload && payload.search && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  if (payload && payload.markup_id) {
    url = url + `markup_id=${payload.markup_id}&`;
  }
  if (payload && payload.carrier_name) {
    url = url + `carrier_name=${payload.carrier_name}&`;
  }
  if (payload && payload.carrier_mode) {
    url = url + `carrier_mode=${payload.carrier_mode}&`;
  }
  if (payload && payload.percentage) {
    url = url + `percentage=${payload.percentage}&`;
  }
  return axiosRef.get(url);
};

export const editCarrierMarkupDetail = (payload: any) =>
  axiosRef.put(`/carrier_markups/${payload.id}`, payload);

// axiosRef.put(`/markups/${payload.id}/history`, payload);

export const fetchMarkupHistory = (payload?: any) => {
  let url = `/markups/${payload.id}/history?`;

  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  return axiosRef.get(url);
};

export const fetchCarrierMarkupHistory = (payload?: any) => {
  let url = `/carrier_markups/${payload.id}/history?`;

  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  return axiosRef.get(url);
};

export const fetchCarrierDetail = (code: any) =>
  axiosRef.get(`/carriers/${code}`);

export const editCarrierDetail = (payload: any) =>
  axiosRef.put(`/carriers/${payload.code}`, payload);

export const fetchCarrierServicesList = (code: any, payload?: any) => {
  let url = `/carrier_services?carrier_code=${code}&`;

  if (payload && payload.search && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  return axiosRef.get(url);
};

export const editCarrierServices = (payload: any) =>
  axiosRef.put(`/carrier_services/${payload.id}`, payload);

export const addCarrierServices = (payload: any) =>
  axiosRef.post(`/carrier_services`, payload);

export const deleteCarrierServices = (id: any) =>
  axiosRef.delete(`/carrier_services/${id}`);

export const fetchCarrierCityList = (code: any, payload?: any) => {
  let url = `/city_alias?carrier_code=${code}&`;

  if (payload && payload.search && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  return axiosRef.get(url);
};

export const editCarrierCity = (payload: any) =>
  axiosRef.put(`/city_alias/${payload.id}`, payload);

export const addCarrierCity = (payload: any) =>
  axiosRef.post(`/city_alias`, payload);

export const deleteCarrierCity = (id: any) =>
  axiosRef.delete(`/city_alias/${id}`);

export const fetchCarrierDispatchList = (code: any, payload?: any) => {
  let url = `/dispatch?carrier_code=${code}&`;

  if (payload && payload.search && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  return axiosRef.get(url);
};

export const editCarrierDispatch = (payload: any) =>
  axiosRef.put(`/dispatch/${payload.id}`, payload);

export const addCarrierDispatch = (payload: any) =>
  axiosRef.post(`/dispatch`, payload);

export const deleteCarrierDispatch = (id: any) =>
  axiosRef.delete(`/dispatch/${id}`);

export const fetchCarrierBillList = (code: any, payload?: any) => {
  let url = `/bill_of_lading?carrier_code=${code}&`;

  if (payload && payload.search && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  return axiosRef.get(url);
};

export const editCarrierBill = (payload: any) =>
  axiosRef.put(`/bill_of_lading/${payload.id}`, payload);

export const addCarrierBill = (payload: any) =>
  axiosRef.post(`/bill_of_lading`, payload);

export const deleteCarrierBill = (id: any) =>
  axiosRef.delete(`/bill_of_lading/${id}`);

export const fetchSailingDatesList = (payload?: any) => {
  let url = `/sailing_dates?`;
  if (payload && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  return axiosRef.get(url);
};

export const editSailingDates = (payload: any) =>
  axiosRef.put(`/sailing_dates/${payload.id}`, payload);

export const fetchPortsList = (payload?: any) => {
  let url = `/ports?`;
  if (payload && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  return axiosRef.get(url);
};

export const editPortsService = (payload: any) =>
  axiosRef.put(`/ports/${payload.id}`, payload);

export const addPortsService = (payload: any) =>
  axiosRef.post(`/ports`, payload);

export const deletePortsService = (id: any) => axiosRef.delete(`/ports/${id}`);

export const fetchPickupRestrictionList = (payload?: any) => {
  let url = `/pickup/restrictions?`;
  if (payload && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.carrier_code) {
    url = url + `carrier_code=${payload.carrier_code}&`;
  }
  return axiosRef.get(url);
};

export const editPickUpRestrictionService = (payload: any) =>
  axiosRef.put(`/pickup/restrictions/${payload.id}`, payload);

export const addPickUpRestrictionService = (payload: any) =>
  axiosRef.post(`/pickup/restrictions`, payload);

export const deletePickUpRestrictionService = (id: any) =>
  axiosRef.delete(`/pickup/restrictions/${id}`);

export const fetchLanesList = (payload?: any) => {
  let url = `/rate_sheets/lane?`;
  if (payload && payload?.pageSize) {
    url = url + `page_size=${payload.pageSize}&page=${payload.page}&`;
  }
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  if (payload && payload.search && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.carrier_code) {
    url = url + `carrier_code=${payload.carrier_code}&`;
  }
  if (payload && payload.account) {
    url = url + `account_number=${payload.account}&`;
  }
  return axiosRef.get(url);
};

export const uploadRateSheetService = (payload: any) =>
  axiosRef.post(`/rate_sheets/upload`, payload);

export const deleteRateSheetLane = (payload: any) =>
  axiosRef.delete(`/rate_sheets/lane`, { data: payload });

export const deleteRateSheetLaneCost = (id: any) =>
  axiosRef.delete(`/rate_sheets/costs/${id}`);

export const getRateSheetLaneDetails = (id: any) =>
  axiosRef.get(`/rate_sheets/lane/${id}`);

export const getRateSheetCostDetails = (id: any) =>
  axiosRef.get(`/rate_sheets/costs?rate_sheet_id=${id}`);
